import { render, staticRenderFns } from "./DamageReport.vue?vue&type=template&id=024cfa90&"
import script from "./DamageReport.vue?vue&type=script&lang=ts&"
export * from "./DamageReport.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports